export enum LegalGroundEnum {
  REGULATION_2017_1129 = 'REGULATION_2017_1129',
  PART_III_PROSPECTUS_LAW = 'PART_III_PROSPECTUS_LAW',
}
